import { useQuery } from 'react-query';

import { getVisitReportsList } from 'api/visitReports/getVisitReportsList';

interface QueryOptions {
  slug: string;
  enabled?: boolean;
}

export const useGetVisitReportsList = ({ slug, enabled = true }: QueryOptions) => {
  const { data, refetch, isLoading } = useQuery(['visitReportsList', slug], () => getVisitReportsList(slug), {
    refetchOnWindowFocus: false,
    refetchInterval: 5000,
    enabled,
  });

  return { data, refetch, isLoading };
};

export default useGetVisitReportsList;
